module.exports = __webpack_public_path__ + "static/media/delrakkin.a38a5f19.jpg";